import FileUploader from "./FileUploader";

function CompanyInformationForm({data, setData, getData}) {
    return (
        <>
            <div className="header">Create Corporate Account</div>
            <div className="form-container">
                <div className="form-title">
                    COMPANY INFORMATION
                </div>
                {
                    data && (
                        <>
                            <div className="form-group">
                                <div className="form-label">Registered Name</div>
                                <input type="text" className="form-input" value={data?.RegisteredName} disabled/>
                            </div>
                            <div className="form-group">
                                <div className="form-label">Type of Business</div>
                                <input type="text" className="form-input" value={data?.TypeOfBusiness} disabled/>
                            </div>
                            <div className="form-group">
                                <div className="form-label">Phone Number</div>
                                <input type="text" className="form-input" value={data?.PhoneNumber} disabled/>
                            </div>
                            <div className="form-group">
                                <div className="form-label">Email</div>
                                <input type="text" className="form-input" value={data.Email} disabled/>
                            </div>
                            <div className="form-group">
                                <div className="form-label">Address</div>
                                <div className="input-pin">
                                    <input type="text" className="form-address" value={data.Address} disabled/>
                                    <img src="/Images/pin.png" className="address-pin" alt=""/>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="form-label file-label">
                                    <div className="label-val">Logo</div>
                                    <div className="description">(Optimal size 300 x 300px)</div>
                                </div>
                                <div className="file-upload">
                                    <FileUploader setFile={(file) => {
                                        setData({
                                            ...getData,
                                            LogoImage: file
                                        });
                                    }} placeholder="Choose Photo"/>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="form-label file-label">
                                    <div className="label-val">Official Documents</div>
                                    <div className="description">(Zip file)</div>
                                </div>
                                <div className="file-upload">
                                    <FileUploader setFile={setData} placeholder="Choose File"/>
                                </div>
                            </div>

                        </>
                    )
                }
            </div>
        </>
    );
}

export default CompanyInformationForm;